module.exports = __webpack_public_path__ + "img/Cr.219c8237.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shot-images/Cr.jpg
// module id = CXrb
// module chunks = 1